
import { Button } from "@/components/ui/button";
import { truncateTitle } from "./utils";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { formatDate } from "./utils";
import { useNavigate, useLocation } from "react-router-dom";

type ChatHistoryItem = {
  id: string;
  title: string;
  created_at: string;
};

interface ChatHistorySectionProps {
  title: string;
  chats: ChatHistoryItem[];
  onChatClick: (chatId: string) => void;
  activeChat?: string | null;
}

export function ChatHistorySection({ title, chats, onChatClick, activeChat }: ChatHistorySectionProps) {
  if (chats.length === 0) return null;
  const navigate = useNavigate();
  const location = useLocation();

  const handleChatClick = (chatId: string, event: React.MouseEvent) => {
    // Prevent default to avoid any unwanted navigation
    event.preventDefault();
    console.log(`Clicked on chat: ${chatId}`);
    
    // Always navigate to /chat route with the chat ID
    // This ensures we stay in the chat UI regardless of current location
    navigate(`/chat?chat=${chatId}`);
    
    // Also call the onChatClick handler
    onChatClick(chatId);
  };

  return (
    <div className="mb-4">
      <p className="text-xs font-semibold text-gray-400 uppercase mb-2">{title}</p>
      {chats.map((chat) => (
        <TooltipProvider key={chat.id}>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                onClick={(e) => handleChatClick(chat.id, e)}
                className={`w-full text-left justify-start font-normal mb-1 rounded-xl truncate ${
                  activeChat === chat.id ? 'bg-blue-600/20 text-blue-200' : ''
                }`}
                variant="ghost"
              >
                <span className="truncate flex-1">{truncateTitle(chat.title)}</span>
              </Button>
            </TooltipTrigger>
            <TooltipContent side="right">
              <div className="max-w-xs">
                <p className="font-medium">{chat.title}</p>
                <p className="text-xs text-gray-400 mt-1">{formatDate(chat.created_at)}</p>
              </div>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      ))}
    </div>
  );
}
